import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/pedido-exames-laudos`

    return {
        remove: id => {
            return repository.delete(`${baseUrl}/${id}`)
        },
        download: (id, params) => {
            return repository.get(`${baseUrl}/${id}/download?${urlUtil.serialize(params)}`, { responseType: "arraybuffer" })
        }
    }
}